import Swiper from "swiper";
import Clipboard from "clipboard";
import { Message } from "element-ui";
// plugins
import eventBus from "@/plugins/eventBus";
import { dateFormat } from "@/plugins/util";
import jsToApp from "@/plugins/jsToApp";
// apis
import { apiPublicGetAliyunVideo } from "@/api/publicApi";
import { apiContentVote } from "@/api/contentApi";

class handleDetailContent {
  constructor(ele, vm) {
    // 内容节点
    this.$ele = $(ele);
    this.$vm = vm;
    this.handleSlideToggle();
    this.handleFoldToggle();
    this.handleVideoUrl();
    this.handleTableSortFilter();
    this.handleSecondary();
    this.handleAudioPlay();
    this.handleCopyVideo();
    this.handleAppLinks();
    this.handleFoldTable();
    this.handleVote();
  }

  // 自动匹配链接

  // 全局替换字符串为网址
  autoLinks(html) {
    let $div = $("<div></div>");
    $div.html(html);
    recursiveHtml($div);

    function recursiveHtml(html) {
      if (!html || html.contents().length <= 0) return;
      html.contents().each(function() {
        if ($(this).contents().length == 0) {
          strReplace($(this));
        } else {
          recursiveHtml($(this));
        }
      });
    }

    function strReplace(html) {
      let $str = html[0].textContent;
      if (!$str) return;
      let reg = /(http:\/\/|https:\/\/|\/\/)((\w|=|\?|\.|\/|&|-)+)/g;
      if (html.parents("a").length > 0) return;
      if (html.parents(".audio-bar").length > 0) return;
      $str = $str.replace(reg, '<a class="a-auto-links" target="_blank" href=\'$1$2\'>$1$2</a>');
      html.after($str).remove();
    }

    return $div.html();
  }

  // 点击换取视频
  handleVideoUrl() {
    const _this = this;
    this.$ele.on("click", ".img-video-div", function() {
      let $this = $(this);
      let key = $this.find(".uploadVideoImg").attr("data-url") || "";
      let poster = $this.find(".uploadVideoImg").attr("src");
      let $videoBox = $this.parents(".video-play-wrapper");
      if (!key || key.length == 0) {
        Message("视频不存在~");
        return;
      }
      if (key.includes("<iframe") || key.startsWith("<video") || key.includes("video-content-ele")) {
        // $this.get(0).outerHTML = key;
        console.log(key);
        $this.after(key).remove();
        $videoBox.find("video").click();
        //  视频来源是华为云，直接可以播放
      } else if (key.includes("wiki2.0/video") || key.includes("qiniu_app_video")) {
        let $video = $(
          `<video autoplay x5-video-player-type="h5" playsinline controls poster="${poster}" src="${key}"></video>`
        );
        $this.after($video).remove();
        $video.click();
      } else if (key.includes("wiki/gamekee/") || key.includes("wiki/content/")) {
        //  阿里云视频
        apiPublicGetAliyunVideo({ url: key }).then(res => {
          console.log({ res });
          let url = res.data.vediourl;
          let $video = $(
            `<video autoplay controls x5-video-player-type="h5" playsinline poster="${poster}" src="${url}"></video>`
          );
          $this.after($video).remove();
          $video.click();
        });
      }
      if ($videoBox.find("video").length && !_this.$vm.device.inApp) {
        let _class = "copy-btn-" + new Date().getTime();
        let $bar = `<div class="video-copy-bar">
        <span>点击按钮即可复制引用该视频~</span>
        <button class="${_class}" data-clipboard-text='${
          $videoBox.find("video").get(0).outerHTML
        }'>复制视频地址</button>
        </div>`;
        $videoBox.find("video").after($bar);
      }
    });
  }

  handleCopyVideo() {
    this.$ele.on("click", ".video-copy-bar button", function() {
      let _class = $(this).attr("class");
      let clipboard = new Clipboard("." + _class);
      clipboard.on("success", e => {
        Message("复制成功！");
        clipboard.destroy();
      });
      clipboard.on("error", e => {
        // 不支持复制
        Message("浏览器不支持自动复制,请更换其他浏览器");
        clipboard.destroy();
      });
    });
  }

  // 点击播放音频
  handleAudioPlay() {
    this.$ele.on("click", ".audio-bar .icon-play", function() {
      let $playBtn = $(this);
      let $audioBar = $(this).parents(".audio-bar");
      let $audio = $audioBar.find("audio").get(0);
      if ($audio.paused) {
        // 播放前关闭其他音频
        $(".audio-bar").each(function() {
          $(this)
            .find("audio")
            .get(0)
            .pause();
          $(this)
            .find(".icon-play")
            .attr("class", "icon-play pause");
        });
        $playBtn.attr("class", "icon-play");
        $audio.play();
      } else {
        $playBtn.attr("class", "icon-play pause");
        $audio.pause();
      }
    });
  }

  // 展开折叠表格
  handleFoldTable() {
    this.$ele.on("click", ".fold-table-title", function() {
      // eslint-disable-next-line
      let $model = $(this)
        .siblings(".fold-table-content")
        .toggle();
    });
  }

  // 页签切换
  handleSlideToggle() {
    this.$ele.on("click", ".slide-model-container .slide-nav-wrapper>div", function() {
      let $this = $(this);
      let $model = $this.parents(".slide-model-container");
      let index = $this.attr("data-index");
      $this.siblings().removeClass("active");
      $this.addClass("active");
      $model.find(".slide-item").removeClass("active");
      $model.find(".slide-item").each(function() {
        let i = $(this).attr("data-index");
        if (i == index) {
          $(this).addClass("active");
        }
      });
      scrollPlusOne();
    });
  }

  // 添加目录功能
  handleCatalog() {
    if (this.$ele.find(".catalog-wrapper").length > 0) {
      eventBus.$emit("setCataVisible", false);
      eventBus.$emit("setCataList", []);
      return;
    }
    let $catalog = this.$ele.find(".catalog-item-wrapper");
    const cataList = [];
    let $catalogWrapper = $(
      '<div><div class="catalog-wrapper"><div class="catalog-content"><p>目录：</p></div></div></div>'
    );
    let color =
      $catalog
        .find(".cata-color-btn")
        .eq(0)
        .attr("data-color") || "#666666";
    $catalogWrapper.find(".catalog-wrapper").css({
      background: color + "11",
      borderColor: color
    });
    let oneLevelLen = 0;
    let secondLevelLen = 0;
    if ($catalog.length <= 0) {
      eventBus.$emit("setCataVisible", false);
      eventBus.$emit("setCataList", []);
      return;
    }
    $catalog.each(function() {
      let title = $(this)
        .find(".catalog-input")
        .attr("value");
      let random = parseInt(Math.random() * 10000000);
      let isSecondLevel = $(this)
        .find(".switch-catalog-btn")
        .hasClass("active");
      let text, $title, $a;
      if (isSecondLevel) {
        secondLevelLen++;
        text = oneLevelLen + "." + secondLevelLen + title;
        $title = $('<div class="catalog-item-title catalog-title2" id="catalog' + random + '">' + text + "</div>");
        $a = $('<div><a class="secondLevel" data-id="#catalog' + random + '">' + text + "</a></div>");
        const obj = {
          oneLevelLen,
          secondLevelLen,
          title,
          dataId: "#catalog" + random
        };
        cataList.push(obj);
      } else {
        secondLevelLen = 0;
        oneLevelLen++;
        text = oneLevelLen + "." + title;
        $title = $('<div class="catalog-item-title catalog-title1" id="catalog' + random + '">' + text + "</div>");
        $a = $('<div><a class="oneLevel" data-id="#catalog' + random + '">' + text + "</a></div>");
        const obj = {
          oneLevelLen,
          secondLevelLen,
          title,
          dataId: "#catalog" + random
        };
        cataList.push(obj);
      }
      $(this).before($title);
      $catalogWrapper.find(".catalog-content").append($a);
    });
    $catalogWrapper.find("a").css("color", color);
    this.$ele.find(".catalog-item-title").css({
      "border-color": color,
      color
    });
    if (cataList.length) {
      eventBus.$emit("setCataVisible", true);
      eventBus.$emit("setCataList", cataList);
    } else {
      eventBus.$emit("setCataVisible", false);
      eventBus.$emit("setCataList", []);
    }
    // this.$ele.prepend($catalogWrapper);
    this.handleCatalogToIndex();
  }

  // 目录跳转到对应位置
  handleCatalogToIndex() {
    this.$ele.on("click", ".catalog-wrapper a", function() {
      let id = $(this).attr("data-id");
      let offsetTop = $(id).get(0).offsetTop;
      window.scrollTo({
        top: offsetTop,
        behavior: "smooth"
      });
    });
  }

  // 字符串转html;
  StrToHtml(str) {
    let $div = document.createElement("div");
    $div.innerHTML = str;
    return $div.childNodes[0];
  }

  // 去除详情页可编辑节点
  handleEleReadOnly() {
    this.$ele.find("*[contenteditable]").removeAttr("contenteditable");
  }

  // 移除多余的空白节点
  removeEmptyEl() {
    this.$ele.find(".min-height-wrapper").each(function() {
      let html = $(this).html();
      if (html === null || html.length <= 0) {
        $(this).remove();
      }
    });
  }

  // 折叠功能显示与隐藏
  handleFoldToggle() {
    this.$ele.on("click", ".fold-title-wrapper", function() {
      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        $(this)
          .next(".fold-content")
          .hide();
      } else {
        $(this).addClass("active");
        $(this)
          .next(".fold-content")
          .show();
        scrollPlusOne();
      }
    });
  }

  // 初始化表格内筛选项
  initTableFilter() {
    this.$ele.find(".thead-filter-btn").each(function() {
      if ($(this).find("ul").length) return;
      let index = $(this).index();
      let $table = $(this)
        .parents(".mould-table-wrap")
        .find(".mould-table");
      let $ul = $("<ul><li>全部</li></ul>");
      $table.find("td").each(function() {
        if ($(this).parents(".sort-thead").length) return;
        let $this = $(this);
        let tdIndex = $this.index();
        let $content = $(this).clone();
        // 移出弹出层中的内容
        $content.find(".dailog-data-wrapper").remove();
        let text = $content.text().trim();
        if (tdIndex == index) {
          let isAdd = false;
          let row = $(this).attr("rowspan") || 1;
          $ul.find("li").each(function() {
            let $li = $(this);
            if ($li.text().trim() == text) {
              isAdd = true;
              //    存在
              $this.attr({
                "data-filter-val": text,
                "data-filter-id": $li.attr("data-id")
              });
            }
          });
          if (!isAdd) {
            let id = parseInt(Math.random() * 1000000000000);
            $ul.append('<li data-id="' + id + '">' + text + "</li>");
            $this.attr({
              "data-filter-val": text,
              "data-filter-id": id
            });
          }
          if (row > 1) {
            $this.parents("tr").attr("data-row", row);
            $this
              .parents("tr")
              .nextAll("tr")
              .each(function(n_i) {
                if (row > n_i + 1) {
                  $(this).attr("data-correlation-index", n_i + 1);
                  $(this).attr("data-correlation-row", $this.parents("tr").index());
                }
              });
          }
        }
      });
      $(this).append($ul);
    });
  }

  initTableFixed() {
    $(".table-overflow").each(function() {
      let $fixedCol;
      // 新的固定列没有单独的表格，需要冲原始表格遍历
      let colIndex =
        $(this)
          .find(".mould-table")
          .attr("data-col-index") || "[]";
      colIndex = JSON.parse(colIndex);
      $(this)
        .find("tr")
        .each(function() {
          $(this).attr("data-index", $(this).index());
        });
      // console.log(colIndex);
      if (colIndex.length) {
        $fixedCol = $('<table class="fixed-col-table"></table>');
        $(this)
          .find(".mould-table")
          .find("tr")
          .each(function() {
            let $tr = $($(this).clone()).empty();
            $tr.attr("data-index", $(this).index());
            if ($(this).hasClass("sort-thead")) {
              $tr.addClass("sort-thead");
            }
            $tr.append($(this).find(".fixed-col-td"));
            $fixedCol.append($tr);
          });
        let $colgroup = $("<colgroup></colgroup>");
        $(this)
          .find("col")
          .each(function(i) {
            if (colIndex.indexOf(i) > -1) {
              $colgroup.append($(this));
            }
          });
        $fixedCol.prepend($colgroup);
      }
      $(this).before($fixedCol);
    });
  }

  handleImgGroup() {
    this.$ele
      .find(".img-group-container")
      .not(".is-swiper")
      .each(function() {
        let r = parseInt(Math.random() * 10000000000);
        $(this).addClass("is-swiper");
        $(this)
          .find(".gallery-thumbs")
          .addClass("thumbs-" + r);
        $(this)
          .find(".gallery-top")
          .addClass("top-" + r);
        $(this)
          .find(".button-next")
          .addClass("next-" + r);
        $(this)
          .find(".button-prev")
          .addClass("prev-" + r);
        let galleryTop = null;
        let galleryThumbs = new Swiper(".thumbs-" + r, {
          spaceBetween: 10,
          slidesPerView: 5,
          freeMode: true,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          centeredSlides: true,
          navigation: {
            nextEl: ".next-" + r,
            prevEl: ".prev-" + r
          },
          observer: true,
          observeParents: true
        });
        galleryTop = new Swiper(".top-" + r, {
          observer: true,
          observeParents: true
        });
        galleryTop.controller.control = galleryThumbs;
        galleryThumbs.controller.control = galleryTop;
      });
  }

  // 处理表格内的排序项，筛选项
  handleTableSortFilter() {
    // 表格内筛选
    this.$ele.on("click", ".thead-filter-btn", function() {
      $(this)
        .find("ul")
        .toggle();
      // 展示筛选项时，去掉表格的超出隐藏；
      if (
        $(this)
          .find("ul")
          .is(":hidden")
      ) {
        $(this)
          .parents(".mould-table-wrap")
          .find(".table-container,.table-overflow")
          .css("overflow-y", "");
      } else {
        $(this)
          .parents(".mould-table-wrap")
          .find(".table-container,.table-overflow")
          .css("overflow-y", "initial");
      }
    });
    this.$ele.on("click", ".thead-filter-btn li", function() {
      let id = $(this).attr("data-id") || 0;
      let $table = $(this).parents(".mould-table-wrap .mould-table");
      // let $table = $(this)
      //   .parents(".mould-table-wrap")
      //   .find(".mould-table");
      let filterArr = JSON.parse($table.attr("data-filter-arr") || "[]");
      // eslint-disable-next-line
      let td_index = $(this)
        .parents("td")
        .index();
      let $trs = $table
        .children("tbody")
        .children("tr")
        .not(".sort-thead");
      if (id > 0 && filterArr.indexOf(id) < 0) {
        filterArr.push(id);
      }

      $(this)
        .siblings("li")
        .each(function() {
          var s_id = $(this).attr("data-id") || 0;
          // 删除同类型的筛选
          if (filterArr.indexOf(s_id) > -1) {
            filterArr.splice(filterArr.indexOf(s_id), 1);
          }
        });
      $table.attr("data-filter-arr", JSON.stringify(filterArr));
      if (filterArr.length == 0) {
        $table
          .children("tbody")
          .children("tr")
          .show();
        reSetColTable($table);
        return;
      }
      // if (id == 0) {
      //     $table.find('tr').show();
      //     reSetColTable($table);
      //     return;
      // }
      $trs.each(function() {
        let count = 0;
        $(this)
          .find("td")
          .each(function() {
            let proptree = $(this).attr("data-proptree") || "[]";
            let filterId = $(this).attr("data-filter-id") || 0;
            let td_id = 0;
            try {
              proptree = JSON.parse(proptree);
              td_id = proptree[0].tree.twoTree.id || 0;
            } catch (e) {
              td_id = 0;
            }
            if (filterId) {
              td_id = filterId;
            }
            if (filterArr.indexOf(td_id) > -1) {
              count++;
            }
          });
        if (count === filterArr.length) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });
      reSetColTable($table);
    });
    // 表格内排序
    this.$ele.on("click", ".thead-sort-btn", function() {
      let $this = $(this);
      let $table = $(this).parents(".mould-table-wrap .mould-table");
      // let $table = $(this).parents(".mould-table-wrap").find(".mould-table");
      let td_index = $(this)
        .parents("td")
        .index();
      if ($this.get(0).nodeName.toLowerCase() === "td") {
        td_index = $(this).index();
      }

      let $trs = $table
        .children("tbody")
        .children("tr")
        .not(".sort-thead")
        .clone();

      $this
        .siblings(".thead-sort-btn")
        .find(".arrow-default")
        .removeClass("arrow-up arrow-down");
      // 排序方向
      let sort = "up";
      if (
        $(this)
          .find(".arrow-default")
          .hasClass("arrow-down")
      ) {
        sort = "down";
        $(this)
          .find(".arrow-default")
          .addClass("arrow-up")
          .removeClass("arrow-down");
      } else {
        sort = "up";
        $(this)
          .find(".arrow-default")
          .addClass("arrow-down")
          .removeClass("arrow-up");
      }
      $trs.sort(function(a, b) {
        let a_val, b_val;
        a_val = $(a)
          .find("td")
          .eq(td_index)
          .text();
        b_val = $(b)
          .find("td")
          .eq(td_index)
          .text();
        let reg = new RegExp(/^\d+%$/);
        if (reg.test(a_val)) {
          a_val = a_val.replace("%", "");
        }
        if (reg.test(b_val)) {
          b_val = b_val.replace("%", "");
        }
        let res = b_val - a_val;
        if (sort == "down") {
          res = a_val - b_val;
        }
        return res;
      });
      $table
        .children("tbody")
        .children("tr")
        .not(".sort-thead")
        .remove();
      $table.append($trs);
      reSetColTable($table);
    });

    function reSetColTable($table) {
      let $colTable = $table.parents(".mould-table-wrap").find(".fixed-col-table");
      let $trs = $colTable.find("tr").clone();
      $colTable.empty();
      $table.find("tr").each(function() {
        let index = $(this).attr("data-index");
        if ($(this).is(":hidden")) {
          $trs.filter('[data-index="' + index + '"]').hide();
        } else {
          $trs.filter('[data-index="' + index + '"]').show();
        }
        $colTable.append($trs.filter('[data-index="' + index + '"]'));
      });
      $colTable.height($table.height());
      syncTr($table);
    }

    // 存在合并行时，同步关联的行
    function syncTr($table) {
      $table.find("tr").each(function() {
        // eslint-disable-next-line
        var c_index = $(this).attr("data-correlation-index") || "";
        var c_row = $(this).attr("data-correlation-row") || "";
        if (c_row) {
          var c_tr = $table.find('tr[data-index="' + c_row + '"]');
          var c_tr_row = $table.find('tr[data-index="' + c_row + '"]').attr("data-row") || 1;
          // c_tr.after($(this));
          for (let i = c_tr_row; i > 0; i--) {
            c_tr.after($table.find("tr[data-correlation-row=" + c_row + "][data-correlation-index=" + i + "]"));
          }
          if (!c_tr.is(":hidden")) {
            $(this).show();
          }
        }
      });
    }
  }

  //  显示显示二级弹窗
  handleSecondary() {
    let isDesktop = this.$vm.device.desktop;
    this.$ele.on(isDesktop ? "mouseenter" : "click", ".secondary-dialog-wrapper", function() {
      const rect = $(this)
        .get(0)
        .getBoundingClientRect();
      let $html = $(this)
        .find(".dailog-data-wrapper")
        .html();
      $html = $(`<div>${$html}</div>`);
      $html.find("img").each(function() {
        $(this).attr("src", $(this).attr("data-src"));
      });
      eventBus.$emit("secondaryData", {
        html: $html.html(),
        target: $(this).get(0),
        rect: rect
      });
    });
  }

  //  替换文章中的图片为默认图片
  replaceImgSrc(html) {
    let $html = $(`<div>${html}</div>`);
    let count = 0;
    $html.find("img").each(function(index) {
      let $img = $(this);
      let src = $img.attr("src");
      $img.attr("data-src", src);
      if ($(this).parents(".selectItem").length > 0) return;
      if (
        $(this).attr("src") &&
        $(this)
          .attr("src")
          .includes(".gif")
      )
        return;
      count++;
      if (count < 5) return;
      $img.addClass("lazy-img");
      $img.removeAttr("src");
    });
    return $html.html();
  }

  //
  hadleTableAutoSize() {
    const _this = this;
    this.$ele.find(".auto-size-table").each(function() {
      let $table = $(this).find("table");
      let $cols = $table
        .find("colgroup")
        .eq(0)
        .find("col");
      let t_w = 0;
      if (!_this.$vm.device.desktop) {
        $cols.each(function() {
          let $col = $(this);
          let style = $(this).attr("style");
          style = style.split(";");
          style.forEach(item => {
            item = item.split(":");
            if (item[0] == "width") {
              let w = parseInt(item[1].replace(/'\D'/g, ""));
              t_w += w;
              $col.attr("data-width", w);
            }
          });
        });
        $cols.each(function() {
          let w = $(this).attr("data-width");
          // console.log($(this), w);
          $(this).css("width", (w / t_w) * 100 + "%");
        });
      }

      $table.css({
        width: t_w > 320 ? "100%" : "auto",
        maxWidth: "100%",
        tableLayout: "auto"
      });
    });
  }

  //  临时方法--针对ba 这个wiki单独单独处理表格适配
  _handleBaTable() {
    if (!this.$ele.parents(".ba-game-content").length) return;
    this.$ele.find("table").each(function() {
      if (!$(this).find(".sort-thead").length) {
        $(this).css({
          width: "auto",
          maxWidth: "100%",
          tableLayout: "auto"
        });
      }
    });
  }

  imgViewShow() {
    let count = 0;
    let $this = this;
    this.$ele.find("img").each(function() {
      if ($(this).parents("table").length) return;
      if ($(this).parents(".gallery-thumbs").length) return;
      if ($(this).hasClass("uploadVideoImg")) return;
      $(this).addClass("img-view-ele");
      $(this).attr("img-count", count);
      count++;
    });
    this.$ele.find(".img-view-ele").click(function() {
      let index = $(this).attr("img-count");
      let imgs = [];
      $this.$ele.find(".img-view-ele").each(function() {
        imgs.push($(this).attr("data-src"));
      });
      if (!$this.$vm.device.inApp) {
        $this.$vm.$imgViewShow(imgs, index);
      } else {
        let params = {
          imgs: imgs.join(","),
          index: Number(index)
        };
        $this.$vm.jsToApp("app_showImgsView", JSON.stringify(params));
      }
    });
  }

  handleAppLinks() {
    if (!this.$vm.device.inApp) return;
    this.$ele.on("click", "a", function(e) {
      let appVersionCode = sessionStorage.getItem("appVersionCode") || 0;
      if (appVersionCode > 118) {
        e.stopPropagation();
        e.preventDefault();
        jsToApp("app_openUrl", $(this).attr("href"));
      }
    });
  }

  handleVote() {
    const _this = this;
    // 选择投票
    this.$ele.on("click", ".vote-model-container ul li", function(e) {
      // 处理label触发click导致的input触发click
      if ($(e.target).is("input")) return;
      const $vote = $(this).parents(".vote-model-container");
      console.log($vote, e, this);
      const vote_type = $vote[0].dataset.vote_type;

      if (vote_type == 1) {
        // 清除已选
        $vote.find("ul li label").removeClass("is-checked");
        // 设置当前选择
        $(this)
          .find("label")
          .addClass("is-checked");
      } else if (vote_type == 2) {
        const vote_limit = Number($vote[0].dataset.vote_limit);
        // 获取已选
        const isCheckedNum = $vote.find("ul li .is-checked").length;

        // 取消选择
        if ($(this).find(".is-checked").length > 0) {
          $(this)
            .find("label")
            .removeClass("is-checked");
          // 获取已选
          const isCheckedNum = $vote.find("ul li .is-checked").length;
          if (isCheckedNum == 0) {
            $vote.find(".btn-group .vote-submit-btn").addClass("disable");
          }
          return;
        }
        // 判断是否达到限制
        if (isCheckedNum >= vote_limit) {
          _this.$vm.$message(`最多可选${vote_limit}项`);
          return;
        }
        // 设置当前选择
        $(this)
          .find("label")
          .addClass("is-checked");
      }

      // 获取已选
      const isCheckedNum = $vote.find("ul li .is-checked").length;
      // 判断是否已选
      if (isCheckedNum > 0) {
        $vote.find(".btn-group .vote-submit-btn").removeClass("disable");
      } else {
        $vote.find(".btn-group .vote-submit-btn").addClass("disable");
      }
    });

    // 投票
    this.$ele.on("click", ".vote-model-container .btn-group .vote-submit-btn", function(e) {
      if (!_this.$vm.isLoginShow("登录后才能投票")) {
        return false;
      }
      if ($(this).hasClass("disable")) {
        _this.$vm.$message(`请选择投票项！`);
        return;
      }
      const $vote = $(this).parents(".vote-model-container");
      const vote_id = $vote[0].dataset.vote_id;
      // eslint-disable-next-line
      const vote_type = $vote[0].dataset.vote_type;
      // 获取投票项Id
      let item_ids = [];
      $vote.find("ul li .is-checked").each(function() {
        console.log(this);
        const $li = $(this).parents("li");
        const item_id = $li[0].dataset.item_id;
        item_ids.push(item_id);
      });
      const params = {
        content_id: _this.$vm.detail.id,
        vote_id: Number(vote_id),
        options: item_ids.map(id => ({ id: Number(id) }))
      };
      console.log(params);
      apiContentVote(params)
        .then(res => {
          if (res && res.code == 0) {
            const vote_list = _this.$vm.detail.vote_list;
            const voteData = vote_list.find(it => it.id == vote_id);
            voteData.is_vote = true;
            voteData.people_num += 1;
            voteData.options = voteData.options.map(it => {
              if (item_ids.includes(it.id + "")) {
                it.is_selected = true;
                it.vote_num += 1;
              }
              return it;
            });

            const html = voteHtml(voteData);
            $vote[0].outerHTML = html;
          }
        })
        .catch(err => {
          console.log(err);
        });
    });
  }

  destroy() {
    this.$ele.off("click", ".img-video-div");
    this.$ele.off("click", ".video-copy-bar button");
    this.$ele.off("click", ".audio-bar .icon-play");
    this.$ele.off("click", ".fold-table-title");
    this.$ele.off("click", ".fold-title-wrapper");
    this.$ele.off("click", ".catalog-wrapper a");
    this.$ele.off("click", ".thead-filter-btn");
    this.$ele.off("click", ".thead-filter-btn li");
    this.$ele.off("click", ".thead-sort-btn");
    this.$ele.off("click", ".slide-model-container .slide-nav-wrapper>div");
    this.$ele.remove();
    this.$ele = null;
    this.$vm = null;
  }
}

// 修改页面滚动1px,触发页签内图片加载
function scrollPlusOne() {
  let scrollTop = window.document.documentElement.scrollTop || window.document.body.scrollTop;

  window.scrollTo({ top: scrollTop + 1 });
}

// 处理投票
export function replaceVote(html, vote_list = []) {
  if (vote_list && Array.isArray(vote_list)) {
    vote_list.forEach((item, index) => {
      const $str = voteHtml(item);
      const r = "\\[\\/?[^\\]]+\\]" + index + "\\[\\/?[^\\]]+\\]";
      const regx = new RegExp(r, "g");
      html = html.replace(regx, $str);
    });
  }
  return html;
}
// 生成投票模块
function voteHtml(data) {
  let $lis = "";
  data.type = Number(data.type);
  let percentage = 0;
  let is_vote_or_end = data.is_vote || data.is_end;
  let total_vote_num = is_vote_or_end ? data.options.reduce((acc, cur) => acc + cur.vote_num, 0) : 0;
  data.options.forEach(item => {
    const inputType = data.type === 1 ? "radio" : "checkbox";
    const inputClass = data.type === 1 ? "input-radio" : "input-checked";
    if (is_vote_or_end) {
      percentage = parseInt((item.vote_num / (total_vote_num || 1)) * 100);
    }
    let $li = `<li class="${item.is_selected ? "active" : ""}" data-item_id="${item.id}">
          ${
            is_vote_or_end && typeof window !== "undefined"
              ? `<div class="percentage" style="width: ${percentage}%;"></div>`
              : ""
          }
          <label role="${inputType}" class="${item.is_selected ? "is-checked" : ""}">
            ${item.image ? `<img data-src="${item.image}" class="lazy-img img-view-ele" />` : ""}
            <span>${item.name}</span>
            <span class="${inputClass}">
              <input type="${inputType}" name="vote-input-${data.id}">
              <i class="wiki-icon wiki-icon-success-checked"></i>
            </span>
            ${
              is_vote_or_end
                ? `<span class="result">
                    <span class="vote-num">${item.vote_num}票</span>
                    <span class="percentage-num">${percentage}%</span>
                  </span>`
                : ""
            }
          </label>
        </li>`;
    $lis += $li;
  });
  let multiple = data.type === 1 ? "" : `（最多可选${data.max_options_num}项）`;
  let $str = `<div class="selectItem vote-model-container ${
    is_vote_or_end ? "is-vote" : ""
  }" contenteditable="false" data-vote_id="${data.id}" data-vote_type="${data.type}" data-vote_limit="${
    data.max_options_num
  }">
        <div class="vote-title" contenteditable="false">${
          data.title
        }<span class="vote-multiple">${multiple}</span></div>
        <div class="vote-info" contenteditable="false">
          ${
            is_vote_or_end
              ? `<span class="vote-people"><span style="color: #FF5144;">${data.people_num}人</span> 参与</span>`
              : ""
          }
          <span class="vote-expire-time">${dateFormat(data.end_at).ymdhms} 截止</span>
        </div>
        <div class="vote-desc" contenteditable="false">${data.desc}</div>
        <ul contenteditable="false">
        ${$lis}
        </ul>
        ${
          is_vote_or_end
            ? ""
            : `<div class="btn-group">
                <button class="vote-submit-btn disable">投票</button>
              </div>`
        }
    </div>`;
  return $str;
}

export default handleDetailContent;
